import React, { Component } from 'react';
import "../../styles/threewaytoggle.css";
import euroIcon from "../../images/pound-white.png";
import cfIcon from "../../images/cf-icon.svg";
import perIcon from "../../images/per-icon.svg";

export class ThreeWayToggle extends Component {

    constructor(props) {
        super(props);
        this.state = {
          active: "-1",
        }
    }

    handleChange = async (input) => {
      await this.setState({ active: input });
      this.props.handleChange(input);
    };


  render() {
    return(
        <div className="tw-toggle">
        <input checked={this.props.active === "-1" ? true : false} type="radio" name="toggle" value='1' onClick={()=> this.handleChange("-1")}/>
        <label className="toggle toggle-yes">
            <img src={euroIcon} className="toggle-icon toggle-icon-euro" alt=""/>
            </label>
        <input  type="radio" name="toggle" checked={this.props.active === '0' ? true : false } value="0" onClick={()=> this.handleChange("0")}/>
        <label className="toggle toggle-yes">
        <img src={perIcon} className="toggle-icon" alt=""/>
        </label>
        <input checked={this.props.active === "1" ? true : false} type="radio" name="toggle" value="-1" onClick={()=> this.handleChange("1")} />
        <label className="toggle toggle-yes">
        <img src={cfIcon} className="toggle-icon" alt=""/>
        </label>

        <span className="activeClass" style={{ left: this.props.active === "-1" ? "2.5%" : this.props.active === "0" ? "31%" : "63%"  }}></span>  
      </div>
    )
  }

}